import { FC, useContext } from 'react';
import { ConfigContext, SMPFlex, SMPProviderLogo, ConfigContextType } from '@velinsi/smp-widgets-ui';
import AgeRestriction, { AgeRestrictionDisplay } from './AgeRestriction';
import { defaultHandleOddProviderClick } from '@sportal365/smp-widget-utils';
import { ISubscriberInfoFn } from '../../main';
import { BookmakerAssetsType } from '../../widgets/MultisportEvents/MultisportEventsWidget';
import { IMultisportEventsLabels, getMultisportEventsLabels } from '../../utils/getMultisportLabels';

export const oddsDisplayInMultisport = (
  dataOddsDisplay: boolean | undefined = false,
  dataBettingLogoDisplay: boolean | undefined = false,
  dataOddsBettingId: string | undefined | null,
): {
  fullOdds: boolean;
  onlyBettingLogo: boolean;
} => {
  const bettingIdsFlag = !!dataOddsBettingId;

  return {
    fullOdds: bettingIdsFlag && dataOddsDisplay,
    onlyBettingLogo: dataOddsDisplay === false && bettingIdsFlag ? dataBettingLogoDisplay : false,
  };
};

interface ProviderLogoProps {
  bookmakerAssets?: BookmakerAssetsType;
  handleClick: ISubscriberInfoFn;
}

export const ProviderLogo: FC<ProviderLogoProps> = ({ bookmakerAssets, handleClick }) => {
  const {
    dataOddsDisplay,
    dataOddsBettingId,
    dataBettingLogoDisplay,
    dataAgeRestrictionDisplay,
    dataLabels,
    dataOptionsDisplay,
    dataOddsClickable,
  } = useContext<ConfigContextType>(ConfigContext);
  const labels = getMultisportEventsLabels(dataLabels as IMultisportEventsLabels);
  const { fullOdds, onlyBettingLogo } = oddsDisplayInMultisport(dataOddsDisplay, dataBettingLogoDisplay, dataOddsBettingId);

  if (fullOdds || onlyBettingLogo) {
    return (
      <>
        <SMPFlex align={'center'} style={{ marginTop: dataOptionsDisplay ? '9px' : '0', gap: '4px' }}>
          <SMPProviderLogo
            target='_blank'
            style={{
              backgroundColor: bookmakerAssets?.backgroundColor ? bookmakerAssets?.backgroundColor : 'transparent',
              backgroundImage: bookmakerAssets?.logo ? `url("${bookmakerAssets?.logo}")` : '',
              width: '81px',
              height: '26px',
            }}
            href={dataOddsClickable && bookmakerAssets?.url ? bookmakerAssets?.url : undefined}
            className={dataOddsClickable ? '' : 'disable-interaction'}
            onClick={(e) => {
              if (dataOddsClickable === false) {
                e.preventDefault();
                return;
              }

              defaultHandleOddProviderClick(handleClick, {
                id: bookmakerAssets?.id,
                name: bookmakerAssets?.name,
                url: bookmakerAssets?.url,
              });
            }}
          />
          {dataAgeRestrictionDisplay === AgeRestrictionDisplay.TOOLTIP && <AgeRestriction text={labels.age_restriction} />}
        </SMPFlex>
        {dataAgeRestrictionDisplay === AgeRestrictionDisplay.VISIBLE && <AgeRestriction text={labels.age_restriction} />}
      </>
    );
  }

  return null;
};
